<template>
    <router-view />
</template>

<style>
@import '@/assets/css/general.css';
</style>